<template>
    <section class="vertical-products-wrap">
        <div class="container">
            <div class="row">

                <vertical-products
                    :title="data.vertical_products_column_1_title"
                    :url="route('storefront.vertical_products.get_products_column', { columnNumber: 1 })"
                    :link="data.vertical_products_column_1_category_link"
                    :link_title="data.vertical_products_link_title"
                >
                </vertical-products>

                <vertical-products
                    :title="data.vertical_products_column_2_title"
                    :url="route('storefront.vertical_products.get_products_column', { columnNumber: 2 })"
                    :link="data.vertical_products_column_2_category_link"
                    :link_title="data.vertical_products_link_title"
                >
                </vertical-products>

                <vertical-products
                    :title="data.vertical_products_column_3_title"
                    :url="route('storefront.vertical_products.get_products_column', { columnNumber: 3 })"
                    :link="data.vertical_products_column_3_category_link"
                    :link_title="data.vertical_products_link_title"
                >
                </vertical-products>

                <vertical-products
                    :title="data.vertical_products_column_4_title"
                    :url="route('storefront.vertical_products.get_products_column', { columnNumber: 4 })"
                    :link="data.vertical_products_column_4_category_link"
                    :link_title="data.vertical_products_link_title"
                >
                </vertical-products>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        props: ['data'],
    };
</script>
